import React, { useState } from "react";
import { useAuth } from "@/lib/auth.jsx";
import api from "@/lib/api";
import { toast } from "sonner";
import { BrandMark } from "@/components/BrandMark.jsx";

const homeFor = (role) => (role === "employee" ? "/portal" : role === "internal_committee" ? "/admin/posh" : "/admin/dashboard");

const errText = (d) => (typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e?.msg || "").join(" ") : "Sign-in failed. Please try again.");

export default function Login() {
  const { user, setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) { window.location.replace(homeFor(user.role)); return null; }

  const onGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("tt_token", r.data.token);
      setUser(r.data.user);
      window.location.href = homeFor(r.data.user.role);
    } catch (err) {
      toast.error(errText(err?.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F4F4F5] flex flex-col">
      <header className="px-6 py-5 flex items-center justify-between border-b border-[#1E1E1E]">
        <BrandMark size="lg" />
        <span className="font-mono text-[10px] tracking-[0.18em] text-[#71717A] uppercase hidden sm:inline">team.thickandthin.media</span>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-md tt-card p-8">
          <div className="tt-label mb-2">Internal access</div>
          <h1 className="text-2xl font-semibold tracking-tight mb-2">Sign in</h1>
          <p className="text-sm text-[#A1A1AA] leading-relaxed mb-6">Accounts are created by an admin in Settings.</p>

          <form onSubmit={onSubmit} className="space-y-3" data-testid="login-form">
            <input type="email" required autoComplete="email" placeholder="you@thickandthin.media" value={email}
              onChange={(e) => setEmail(e.target.value)} className="tt-input" data-testid="login-email-input" />
            <input type="password" required autoComplete="current-password" placeholder="Password" value={password}
              onChange={(e) => setPassword(e.target.value)} className="tt-input" data-testid="login-password-input" />
            <button type="submit" disabled={busy} className="tt-btn-primary w-full !py-3 disabled:opacity-50" data-testid="login-submit-button">
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="relative my-6"><div className="h-px bg-[#1E1E1E]" /><span className="absolute left-1/2 -translate-x-1/2 -top-2 bg-[#121212] px-3 font-mono text-[10px] tracking-[0.18em] text-[#71717A] uppercase">or</span></div>

          <button data-testid="login-google-btn" onClick={onGoogle}
            className="w-full flex items-center justify-center gap-3 bg-[#1A1A1A] hover:bg-[#242424] text-[#F4F4F5] border border-[#262626] px-4 py-3 rounded-md transition-colors">
            <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.8-5.5 3.8-3.3 0-6-2.7-6-6s2.7-6 6-6c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.9 3.4 14.7 2.4 12 2.4 6.7 2.4 2.4 6.7 2.4 12s4.3 9.6 9.6 9.6c5.5 0 9.2-3.9 9.2-9.4 0-.6-.1-1.1-.2-1.6H12z"/>
            </svg>
            <span className="text-sm font-medium">Continue with Google</span>
          </button>
        </div>
      </main>
    </div>
  );
}
